/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import APICallService from '../../../../api/apiCallService'
import { NOTIFICATION } from '../../../../api/apiEndPoints'
import { defaultJson } from '../../../../api/apiJSON/default'
import { useAuth } from '../../../../app/modules/auth'
import { INotification } from '../../../../types/responseIndex'
import { PAGE_LIMIT } from '../../../../utils/constants'
import Skeleton, { SkeletonTheme } from '../../../../app/custom/skeleton/index'
import '../../../../app/custom/skeleton/skeleton.css'
import Method from '../../../../utils/methods'

const HeaderNotificationsMenu = (props: any) => {
  const [notification, setNotification] = useState<INotification | undefined>(undefined)
  const [page, setPage] = useState(1)
  const [totalRecords, setTotalRecords] = useState(0)
  const [loading, setLoading] = useState(false)
  const { currentUser } = useAuth()

  useEffect(() => {
    if (!props.show) return

    setPage(1)
    setNotification(undefined)
    setTotalRecords(0)

    ;(async () => {
      setLoading(true)
      await fetchNotification(1, [])
      setLoading(false)
    })()
  }, [props.show])

  const handleScroll = async (e: any) => {
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight
    if (bottom && notification && notification.length < totalRecords) {
      const nextPage = page + 1
      setPage(nextPage)
      await fetchNotification(nextPage, notification)
    }
  }

  const fetchNotification = async (pageNo: number, existingNotifications: INotification = []) => {
    const params = {
      pageNo: pageNo,
      limit: PAGE_LIMIT,
      sortKey: '_createdAt',
      sortOrder: -1,
    }
    const apiService = new APICallService(
      NOTIFICATION.GETNOTFICATION,
      defaultJson.listGeneral(params),
      { id: currentUser?.business.profile }
    )
    const response = await apiService.callAPI()
    if (response) {
      if (pageNo === 1) {
        setTotalRecords(response.total ?? response.records?.length ?? 0)
      }
      const data: INotification =
        pageNo === 1 ? [] : [...existingNotifications]
      response.records.forEach((val: INotification[0]) => {
        data.push(val)
      })
      setNotification(data)
    }
  }

  return (
    <div
      className={clsx(
        'absolute right-0 top-full mt-1 w-80 bg-white rounded-lg shadow-lg border border-gray-200 z-50',
        props.show ? 'block' : 'hidden'
      )}
    >
      <div className='flex items-center justify-between px-4 py-3 border-b border-gray-200'>
        <h3 className='text-base font-bold text-gray-900'>Notifications</h3>
        {props.unreadCount > 0 && (
          <button
            type='button'
            className='text-xs font-medium text-blue-600 hover:text-blue-800'
            onClick={props.onMarkAllAsRead}
          >
            Mark all as read
          </button>
        )}
      </div>
      <div className='overflow-y-auto max-h-72' onScroll={handleScroll}>
        {loading ? (
          [1, 2, 3, 4, 5].map((val: any, index: number) => (
            <div key={val} className='px-3 my-4'>
              <SkeletonTheme baseColor='#fafafa' highlightColor='#f7f7f7'>
                <Skeleton count={1} width={'100%'} height={40} inline />
              </SkeletonTheme>
              {index !== 4 && <div className='border-b border-gray-100 mt-2' />}
            </div>
          ))
        ) : notification && notification.length ? (
          notification.map((notifVal: any) => (
            <div key={notifVal._id}>
              <div className='flex items-start gap-3 px-4 py-3'>
                <div className='shrink-0 mt-0.5'>
                  <img src={notifVal.image} alt='' height={36} width={36} className='rounded-full' />
                </div>
                <div className='flex-1 min-w-0'>
                  <p className='text-sm text-gray-800 font-medium mb-0.5'>{notifVal.message}</p>
                  <span className='text-xs text-gray-400'>
                    {Method.convertNotificationDate(notifVal._createdAt)}
                  </span>
                </div>
              </div>
              <div className='border-b border-gray-100' />
            </div>
          ))
        ) : (
          <div className='flex items-center justify-center h-32'>
            <span className='text-sm text-gray-500'>No notifications available</span>
          </div>
        )}
      </div>
    </div>
  )
}

export { HeaderNotificationsMenu }
